const DEFAULT_PIXEL_RATIO = 2;

export default () => {
  return window.devicePixelRatio > DEFAULT_PIXEL_RATIO ? DEFAULT_PIXEL_RATIO : window.devicePixelRatio;
};
